export enum ParticipateDialogs {
  PARTICIPATE_DIALOG = 'PARTICIPATE_DIALOG',
}
